var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.label)?_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.label)+"\n        "),(_vm.required)?_c('span',{staticClass:"required-field-mark"},[_vm._v("*")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('b-form-timepicker',_vm._g(_vm._b({},'b-form-timepicker',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }